import React, { useState, useCallback, useEffect } from "react";
import Cropper from "react-easy-crop";

export default function CropModal({ file, onClose, onComplete }) {
  const [imageUrl, setImageUrl] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedPixels, setCroppedPixels] = useState(null);

  const FIXED_WIDTH = 650;
  const FIXED_HEIGHT = 470;

  // ✅ Load image + reset state
  useEffect(() => {
    if (!file) return;

    const url = URL.createObjectURL(file);
    setImageUrl(url);

    // 🔥 IMPORTANT: reset crop for new image
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setCroppedPixels(null);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedPixels(croppedAreaPixels);
  }, []);

  // ✅ Generate cropped image
  const generateCroppedImage = async () => {
    if (!croppedPixels || !imageUrl) return;

    const img = new Image();
    img.src = imageUrl;

    await new Promise((resolve) => {
      img.onload = resolve;
    });

    const canvas = document.createElement("canvas");
    canvas.width = FIXED_WIDTH;
    canvas.height = FIXED_HEIGHT;

    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      img,
      croppedPixels.x,
      croppedPixels.y,
      croppedPixels.width,
      croppedPixels.height,
      0,
      0,
      FIXED_WIDTH,
      FIXED_HEIGHT
    );

    canvas.toBlob(
      (blob) => {
        if (blob) {
          onComplete(blob); // ✅ parent handles next image / closing
        }
      },
      "image/jpeg",
      0.9
    );
  };

  if (!imageUrl) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "80%",
          height: "80%",
          background: "#111",
          borderRadius: "10px",
        }}
      >
        {/* Cropper */}
        <Cropper
          image={imageUrl}
          crop={crop}
          zoom={zoom}
          aspect={650 / 470}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
          style={{
            containerStyle: { borderRadius: 10 },
          }}
        />

        {/* Zoom control */}
        <div
          style={{
            position: "absolute",
            bottom: 20,
            left: 20,
            right: 220,
            display: "flex",
            alignItems: "center",
            gap: "10px",
            zIndex: 10,
            color: "#fff",
          }}
        >
          <span style={{ fontSize: 18, lineHeight: 1 }}>−</span>
          <input
            type="range"
            min={1}
            max={3}
            step={0.05}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            style={{ flex: 1 }}
          />
          <span style={{ fontSize: 20, lineHeight: 1 }}>+</span>
        </div>

        {/* Buttons */}
        <div
          style={{
            position: "absolute",
            bottom: 20,
            right: 20,
            display: "flex",
            gap: "10px",
            zIndex: 10,
          }}
        >
          {/* Cancel */}
          <button onClick={onClose} className="default-btn">
            Cancel
          </button>

          {/* Save Crop */}
          <button onClick={generateCroppedImage} className="theme-btn">
            Save Crop
          </button>
        </div>
      </div>
    </div>
  );
}